import { Box } from "@mui/material";
import { TopNav } from "../components/TopNav.tsx";
import { MenuDrawer } from "../components/MenuDrawer.tsx";
import { DrawerHeader } from "../components/styled/DrawerHeader.tsx";
import { Modals } from "../components/Modals.tsx";
import { Footer } from "../components/Footer.tsx";
import { useScrollToTop } from "../util/ScrollToTop.ts";
import { Main } from "../components/styled/Main.tsx";
import { useMenuDrawer } from "../util/useMenuDrawer.ts";
import headerHires from "../assets/header-hires.png";
import { ReactNode } from "react";

type HeroContainerProps = {
  headerContent: ReactNode;
  bodyContent?: ReactNode;
  fullWidthBodyContent?: ReactNode;
};

const HeroContainer = ({
  headerContent,
  bodyContent,
  fullWidthBodyContent,
}: HeroContainerProps) => {
  useScrollToTop();
  const { open, handleDrawerOpen, handleDrawerClose } = useMenuDrawer();

  return (
    <Box sx={{ display: "flex" }}>
      <TopNav open={open} handleDrawerOpen={handleDrawerOpen} />
      <MenuDrawer open={open} handleDrawerClose={handleDrawerClose} />
      <Main open={open}>
        <Box
          sx={{
            backgroundColor: "#004B73",
            backgroundImage: `url(${headerHires})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <DrawerHeader />
          <Box sx={{ padding: 6, display: "flex", justifyContent: "center" }}>
            {headerContent}
          </Box>
        </Box>
        {bodyContent && (
          <Box sx={{ padding: 6, display: "flex", justifyContent: "center" }}>
            {bodyContent}
          </Box>
        )}
        {fullWidthBodyContent && <Box>{fullWidthBodyContent}</Box>}
        <Box
          sx={{
            marginLeft: 6,
            marginRight: 6,
            marginTop: 6,
            marginBottom: 6,
          }}
        >
          <Footer />
        </Box>
        <Modals />
      </Main>
    </Box>
  );
};

export default HeroContainer;
